import styled from 'styled-components';
import { borderRadius, colorUsage, fontWeight, getSpacing, shadow, transitionDuration, zIndex } from 'stylesheet';
var ToolbarContainer = styled.div.withConfig({
  displayName: "InlineToolbarstyle__ToolbarContainer",
  componentId: "sc-4asvh4-0"
})(["position:absolute;z-index:", ";display:flex;flex-direction:column;align-items:center;padding:", ";background-color:", ";border:1px solid ", ";border-radius:", ";box-shadow:", ";transition:bottom ", ",left ", ";"], zIndex.WYSIWYGToolbar, getSpacing(0.5), colorUsage.pageForeground, colorUsage.inlineToolbarBorderBorder, borderRadius.small, shadow.bottom.dark, transitionDuration["default"], transitionDuration["default"]);
var ButtonContainer = styled.div.withConfig({
  displayName: "InlineToolbarstyle__ButtonContainer",
  componentId: "sc-4asvh4-1"
})(["display:flex;align-items:center;line-height:initial;"]);
var GenericBlockToggle = styled.span.withConfig({
  displayName: "InlineToolbarstyle__GenericBlockToggle",
  componentId: "sc-4asvh4-2"
})(["display:flex;align-items:center;justify-content:center;width:24px;height:24px;margin-left:", ";color:", ";cursor:pointer;transition:color ", ";& path{transition:fill ", ";fill:", ";}&:hover{color:", ";& path{fill:", ";}}"], getSpacing(0.5), function (_ref) {
  var toggled = _ref.toggled;
  return true === toggled ? colorUsage.inlineToolbarToggleHoverForeground : colorUsage.iconForeground;
}, transitionDuration["default"], transitionDuration["default"], function (_ref2) {
  var toggled = _ref2.toggled;
  return true === toggled ? colorUsage.inlineToolbarToggleHoverForeground : colorUsage.iconForeground;
}, colorUsage.inlineToolbarToggleHoverForeground, colorUsage.inlineToolbarToggleHoverForeground);
var HorizontalSeparator = styled.span.withConfig({
  displayName: "InlineToolbarstyle__HorizontalSeparator",
  componentId: "sc-4asvh4-3"
})(["align-self:stretch;margin:", " 0;border-top:1px solid ", ";"], getSpacing(0.5), colorUsage.inputBorder);
var VerticalSeparator = styled.span.withConfig({
  displayName: "InlineToolbarstyle__VerticalSeparator",
  componentId: "sc-4asvh4-4"
})(["align-self:stretch;margin-left:", ";border-left:1px solid ", ";"], getSpacing(0.5), colorUsage.inputBorder);
var LinkToggle = styled(GenericBlockToggle).withConfig({
  displayName: "InlineToolbarstyle__LinkToggle",
  componentId: "sc-4asvh4-5"
})([""]);
var BoldStyleToggle = styled(GenericBlockToggle).withConfig({
  displayName: "InlineToolbarstyle__BoldStyleToggle",
  componentId: "sc-4asvh4-6"
})(["font-weight:", ";"], fontWeight.bolder);
var ItalicStyleToggle = styled(GenericBlockToggle).withConfig({
  displayName: "InlineToolbarstyle__ItalicStyleToggle",
  componentId: "sc-4asvh4-7"
})(["font-style:italic;"]);
var UnderlineStyleToggle = styled(GenericBlockToggle).withConfig({
  displayName: "InlineToolbarstyle__UnderlineStyleToggle",
  componentId: "sc-4asvh4-8"
})(["text-decoration:underline;"]);
var SuperScriptStyleToggle = styled(GenericBlockToggle).withConfig({
  displayName: "InlineToolbarstyle__SuperScriptStyleToggle",
  componentId: "sc-4asvh4-9"
})([""]);
var ResetStyleToggle = styled(GenericBlockToggle).withConfig({
  displayName: "InlineToolbarstyle__ResetStyleToggle",
  componentId: "sc-4asvh4-10"
})(["&:hover path{stroke:", ";}"], colorUsage.inlineToolbarToggleHoverForeground);
var HighlightToggle = styled(GenericBlockToggle).withConfig({
  displayName: "InlineToolbarstyle__HighlightToggle",
  componentId: "sc-4asvh4-11"
})([""]);
export { BoldStyleToggle, ButtonContainer, HighlightToggle, HorizontalSeparator, ItalicStyleToggle, LinkToggle, ResetStyleToggle, SuperScriptStyleToggle, ToolbarContainer, UnderlineStyleToggle, VerticalSeparator };